export const areaUnits: { [key: string]: string } = {
  M2: 'm²',
  FT2: 'ft²',
}
